export const checkoutIreland = {
  postcode: {
    label: 'Eircode',
  },
  invalid_post_code_found: 'Unfortunately this Eircode could not be located',
}
